import { IProjectRepository } from "domain/contracts/project.contract";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { Project } from "domain/entities/project";
import { ProjectInputFilter } from "domain/models/project-input-filter";
import { formatDate } from "presentation/utils/formatEndDate";

class ProjectRepository implements IProjectRepository {
  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/project/${id}`);
    return response.data;
  }

  async create(input: Project): Promise<Message<Project>> {
    
    let endAt = formatDate(input.endAt);
    let startAt = formatDate(input.startAt);
    let newInput: any = { ...input, endAt: endAt, startAt: startAt };
  
    const response = await httpClient.post(`/project`, { data: newInput });
    return response.data;
  }

  async update(input: Project): Promise<Message<boolean>> {
    let endAt = formatDate(input.endAt);
    let startAt = formatDate(input.startAt);
    let newInput: any = { ...input, endAt: endAt, startAt: startAt };

    const response = await httpClient.put(`/project/${input.id}`, {
      data: newInput,
    });
    return response.data;
  }

  async getAll(filter: ProjectInputFilter): Promise<Message<Project[]>> {
    const response = await httpClient.get(`/project`, { params: filter });
    return response.data;
  }

  async getById(id: string): Promise<Message<Project>> {
    const response = await httpClient.get(`/project/${id}`);
    return response.data;
  }
}

export default new ProjectRepository();
